module.exports = __webpack_public_path__ + "media/images/green_dropdown_arrow-21f24824f9f9a0097c0d0f7be4b55a6e.svg";